/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Load_Failed2Inputs */

const vi_cmspostcategory_load_failed2 = /** @type {(inputs: Cmspostcategory_Load_Failed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được chuyên mục. Tải lại trang để thử lại.`)
};

/**

* @param {Cmspostcategory_Load_Failed2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_load_failed2 = /** @type {((inputs?: Cmspostcategory_Load_Failed2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Load_Failed2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_load_failed2(inputs)
});
export { cmspostcategory_load_failed2 as "cmsPostCategory_load_failed" }